// Vodorovná rolovací lišta ([data-rolovani]): data-pokracuje = vpravo je ještě obsah, data-zpet = lišta
// je odrolovaná a vlevo je obsah. Podle nich base.css prolíná okraje, za kterými lišta pokračuje.
(function () {
  if (window.mlRolovaciLista) return;
  window.mlRolovaciLista = true;

  function stav(el) {
    el.toggleAttribute('data-pokracuje', el.scrollLeft + el.clientWidth < el.scrollWidth - 2);
    el.toggleAttribute('data-zpet', el.scrollLeft > 2);
  }
  function napoj(el) {
    stav(el);
    if (el.mlRolovani) return;
    el.mlRolovani = true;
    el.addEventListener('scroll', function () { stav(el); }, { passive: true });
  }
  function vse() { document.querySelectorAll('[data-rolovani]').forEach(napoj); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vse); else vse();
  window.addEventListener('resize', vse);
  document.addEventListener('shopify:section:load', vse);
})();
